import { render } from "./StepAddMessagePage.vue?vue&type=template&id=183f2bac"
import script from "./StepAddMessagePage.vue?vue&type=script&lang=js"
export * from "./StepAddMessagePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__